import React from 'react'  
import PropTypes from 'prop-types'
import axios from 'axios';
import CardSlider from './CardSlider'
import { CARD_HEADLINE_STYLES } from './Card';

import _ from 'lodash'

class RafflesSlider extends React.Component {
  constructor () {
    super();
    this.state = {
      raffles: []
    };
  }

  componentWillMount () {
    axios.get( '/api/raffles' )
    .then(response => {

      let transformed = []
      response.data.map((item, index) =>
        transformed.push(
          {
            key: item.id,
            image: item.img,
            imageLink: item.link,
            headline: item.title,
            headlineLink: item.link,
          }
        )
      )
      this.setState({ raffles: transformed});
    })
    .catch(error => {
      console.error(error);
    });
  }
  render () {
    return (
        this.state.raffles.length > 0 && 
        <div>
          <h2 className="subtitle" >
            {this.props.title}<span className="sk_show-all"><a href={this.props.linkUrl}>{this.props.linkText}</a></span>
          </h2>

          <CardSlider showButtons={true} items={this.state.raffles} cardHeadlineStyle={CARD_HEADLINE_STYLES.REGULAR} />
        </div>
    );
  }
}

export default RafflesSlider;